// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__2Gt2j"};